import { Box, Skeleton } from "@mui/material";

const MeetingRoomListSkeletonItem = () => {
  return <Skeleton variant="rectangular" width="100%" height={30} />;
};

export default MeetingRoomListSkeletonItem;
